import React from 'react';
import Drawer from '@atlaskit/drawer';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl';
import { defaultProps as projectCreateDefaultProps } from '@atlassian/jira-project-create-old/async';
import { useQueryParam } from '@atlassian/jira-router';
import type { DrawerContentProps } from '../types';
import messages from './messages';

const CrossIconMedium = injectIntl((props) => (
	<CrossIcon size="medium" label={props.intl.formatMessage(messages.close)} />
));

const DrawerContent = (props: DrawerContentProps) => {
	const {
		onClose,
		baseUrl,
		isAdmin,
		isOnboarding,
		data,
		appEditions,
		methods,
		onScreenChange,
		onPermissionsFetched,
		ProjectCreate,
	} = props;
	const defaultSelectedTemplateKey =
		data.defaultSelectedTemplateKey !== undefined
			? data.defaultSelectedTemplateKey
			: projectCreateDefaultProps.defaultSelectedTemplateKey;
	const isTemplatePickerOpenInitially =
		data.isTemplatePickerOpenInitially !== undefined
			? data.isTemplatePickerOpenInitially
			: projectCreateDefaultProps.isTemplatePickerOpenInitially;
	const isImportProjectOpenInitially =
		data.isImportProjectOpenInitially !== undefined
			? data.isImportProjectOpenInitially
			: projectCreateDefaultProps.isImportProjectOpenInitially;
	const selectedProjectType =
		data.selectedProjectType !== undefined
			? data.selectedProjectType
			: projectCreateDefaultProps.selectedProjectType;
	let source = data.source !== undefined ? data.source : projectCreateDefaultProps.source;

	// https://softwareteams.atlassian.net/browse/RLSS-4346
	const [originSource] = useQueryParam('originSource');
	if (!source && originSource !== undefined) {
		source = originSource;
	}

	const drawerOverrides = {
		Sidebar: { component: () => null },
		// @ts-expect-error - TS7006 - Parameter 'styles' implicitly has an 'any' type.
		Content: { cssFn: (styles) => ({ ...styles, margin: 0 }) },
	};

	return (
		<Drawer
			isOpen={data.isOpen}
			width="full"
			onClose={onClose}
			icon={CrossIconMedium}
			// eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
			overrides={drawerOverrides}
			autoFocusFirstElem
		>
			<ProjectCreate
				baseUrl={baseUrl}
				isAdmin={isAdmin}
				isOnboarding={isOnboarding}
				isJswOnboarding={false}
				isJiraCoreOnboarding={false}
				skipTemplateSelection={false}
				isNextGen={data.isNextGen}
				showExperienceSelection={data.showExperienceSelection}
				recommendedTemplate={data.recommendedTemplate}
				isConnectedProjectScenario={false}
				defaultSelectedTemplateKey={defaultSelectedTemplateKey}
				isTemplatePickerOpenInitially={isTemplatePickerOpenInitially}
				isImportProjectOpenInitially={isImportProjectOpenInitially}
				selectedProjectType={selectedProjectType}
				appEditions={appEditions}
				onCancel={methods.close}
				onSuccess={methods.onSuccess}
				onScreenChange={onScreenChange}
				onPermissionsFetched={onPermissionsFetched}
				source={source}
				onDrawerClose={onClose}
				setOnCloseCallback={methods.setOnCloseCallback}
				onCreateStarted={methods.onCreateStarted}
				recommendationSessionID={data.recommendationSessionId}
			/>
		</Drawer>
	);
};

export default DrawerContent;
